
/**
 * Loader API Version: 2
 * Is this in "webpack mode": true
 */
export default {
    "deviceProtection": "Safeguards your device from malware and other security threats. When turned off, safety features will be disabled.",
    "vpn": "Encrypts your internet connection on device and hides your IP address for private, secure browsing. Turn off to disable protection.",
    "adBlocking": "Improves your browsing experience by blocking unwanted ads, pop-ups, and trackers, so pages load faster and stay free of distractions.",
    "ipAddress": "IP Address is the address of the device on the network.",
    "macAddress": "MAC Address is the address of the device on the network.",
    "internetSafeSearch": "Keeps your browsing family-friendly by filtering out explicit or inappropriate content from search results.",
    "youtubeSafeSearch": "Keeps YouTube safe for kids and families by blocking adult or harmful videos.",
    "blockAdultContent": "Helps protect kids and families by blocking adult or unsafe websites.",
    "vpnKillswitch": "VPN Killswitch is a feature that protects your devices from unwanted traffic. It is a feature that protects your devices from unwanted traffic.",
    "malwareAndPhishing": "Helps keep you safe online by blocking dangerous websites that may try to install viruses, steal your personal information, or harm your device."
}
